module.exports = __webpack_public_path__ + "img/logo-light.2dc3b4ec.png";